import { render, staticRenderFns } from "./SuggestBuy.vue?vue&type=template&id=74188a9c&scoped=true"
import script from "./SuggestBuy.vue?vue&type=script&lang=js"
export * from "./SuggestBuy.vue?vue&type=script&lang=js"
import style0 from "./SuggestBuy.vue?vue&type=style&index=0&id=74188a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74188a9c",
  null
  
)

export default component.exports